import type { ReactNode } from "react";

export function HomeSlot({ label, children }: { label: string; children: ReactNode }) {
  return (
    <section
      aria-label={label}
      data-home-slot
      className="relative mx-auto flex w-full max-w-[1180px] flex-col gap-(--gap) px-[40px] pt-[44px] pb-[10px]"
    >
      {children}
    </section>
  );
}
